import { Location as NgLocation } from "@angular/common";
import { HttpInterceptorFn } from "@angular/common/http";
import { DOCUMENT, inject } from "@angular/core";
import { MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalInterceptor, MsalInterceptorConfiguration, MsalService } from "@azure/msal-angular";

// Wrap deprecated interceptor class format into new interceptor function format
// Use their interceptor function if Microsoft provide them in the future

export const msalInterceptor: HttpInterceptorFn = (request, next) => {
  const instance = new MsalInterceptor(
    inject<MsalInterceptorConfiguration>(MSAL_INTERCEPTOR_CONFIG),
    inject(MsalService),
    inject(NgLocation),
    inject(MsalBroadcastService),
    inject(DOCUMENT, { optional: true }) ?? window.document
  );
  return instance.intercept.call(instance, request, { handle: (...args) => next(...args) });
};
